import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * 源谷 OA · ProLayout 兼容配置
 * 注：自定义 AppShell 已接管真实渲染，这里保留是为路由级 layout:false 仍能被识别。
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // Mint / Emerald 主色，与 design-tokens.ts DS.color.primary500 一致
  colorPrimary: '#10b981',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '源谷 OA',
  pwa: process.env.NODE_ENV === 'production',
  logo: undefined,
  iconfontUrl: '',
  token: {},
};

export default Settings;
